import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'
import { darken, lighten } from 'polished'
import { Link } from 'gatsby'
import theme from 'src/utils/styles/theme'

export const CountdownSection = styled.div`
  position: relative;
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.frame2 ? `-31px` : props.frame ? `40px` : '0px')};
  // Styling this outside the Section container leads to order and specificity issues in production after bundling/minification
  & .countdown-background-image {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
    min-height: 100%;
    z-index: 1;
    object-fit: cover;
  }
  @media (max-width: ${breakpoints.l}px) {
    margin-top: ${(props) => (props.frame ? `40px` : '0px')};
  }

  @media (max-width: ${breakpoints.s}px) {
    display: block;
    margin-top: ${(props) => (props.marginTop ? `32px` : '0px')};
    padding: 32px;
    object-fit: cover;
  }
`

export const CountdownSectionContainer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  column-gap: 140px;
  text-align: center;
  @media (max-width: ${breakpoints.l}px) {
    row-gap: 8px;
    width: 100%;
    padding: 0px;
  }
`
export const Header = styled.h2`
  margin: 0px;
  color: ${(props) => props.headerColor || theme.white};
  text-align: center;
  font-family: 'FilsonProBold';
  font-size: 34.228px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%; /* 47.919px */
  letter-spacing: 3.423px;
  text-transform: uppercase;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 20px;
    letter-spacing: 2px;
  }
`

export const SubHeader = styled.p`
  color: ${(props) => props.subHeaderColor || theme.white};
  text-align: center;
  font-feature-settings: 'liga' off;
  font-family: 'FilsonProBold';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 28px */
  @media (max-width: ${breakpoints.s}px) {
    font-size: 18px;
  }
`

export const Time = styled.p`
  color: ${(props) => props.timeColor || theme.white};
  text-align: center;
  margin: 0px;
  font-family: 'FilsonProBold';
  font-size: 65.495px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 91.693px */
  letter-spacing: 0.065px;
  text-transform: uppercase;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 41px;
    letter-spacing: 0.041px;
  }
`
export const CountDownContainer = styled.div`
  margin: auto 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: ${breakpoints.s}px) {
    padding-top: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
`
export const Label = styled.p`
  font-family: 'FilsonProBold';
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 1.4px;
  margin: 0px;
  text-align: center;
  color: ${(props) => props.labelColor || theme.white};
  @media (max-width: ${breakpoints.m}px) {
    font-family: 12px;
    line-height: 16px;
    letter-spacing: 1.2px;
  }
`
export const ColonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin-top: -20px;
  @media (max-width: 340px) {
    padding: 8px;
  }
`
export const TextContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${breakpoints.s}px) {
    width: 100%;
  }
`

export const BuyNowContainer = styled.div`
  text-align: center;
  margin: 10px;
`
export const BuyNowLink = styled(Link)`
  display: inline-block;
  background-color: ${(props) => props.ctaBgColor || theme.coral};
  border-radius: 28px;
  border: none;
  text-decoration: none;
  padding: ${(props) => (props.big ? '12px 64px' : '10px 30px')};
  margin-right: ${(props) => (props.marginRight ? '16px' : '0px')};
  &:hover {
    cursor: pointer;
    background-color: ${(props) => darken(0.1, props.ctaBgColor || theme.coral)};
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => `0 0 0 0.2rem ${lighten(0.1, props.ctaBgColor || theme.coral)}`};
  }
  @media (max-width: 850px) {
    width: 100%;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: 0.08px;
    padding: ${(props) => (props.big ? '13px 64px' : '13px 20px')};
  }
  @media (max-width: ${breakpoints.s}px) {
    background-color: transparent;

    &:hover {
      cursor: pointer;
      background-color: transparent;
      outline: none;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`

export const BuyNowText = styled.p`
  margin: 0px;
  color: ${(props) => props.ctaTextColor || theme.white};
  text-align: center;
  font-family: 'FilsonProBold';
  font-size: 18px;
  font-style: normal;
  text-decoration: none;
  font-weight: 700;
  line-height: 20.68px; /* 114.891% */
  letter-spacing: 0.081px;

  @media (max-width: ${breakpoints.s}px) {
    color: ${(props) => props.ctaTextColorMobile || theme.white};
    line-height: 19.598px; /* 111.094% */
    letter-spacing: 0.077px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    ::after {
      content: ' →';
      font-size: 1.2rem;
      text-decoration: underline;
    }
  }
`
export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 4px;
  width: 100px;
  margin-top: 0px;
  @media (max-width: ${breakpoints.s}px) {
    width: 48px;
  }
`

export const HideOnMobile = styled.div`
  display: block;
  @media (max-width: ${breakpoints.s}px) {
    display: none;
  }
`
export const HideOnDesktop = styled.div`
  display: none;
  @media (max-width: ${breakpoints.s}px) {
    display: block;
  }
`
